import React from 'react'
import Modal from './component'

export default Modal
